// Format number to currency
export const formatCurrency = (amount: number, currency: string = '₽'): string => {
  return `${amount.toFixed(2)} ${currency}`
}

// Format large numbers with K, M suffix
export const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`
  }
  return num.toString()
}

// Format date to readable string
export const formatDate = (date: string | Date): string => {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

// Format timestamp to Moscow timezone (Europe/Moscow, UTC+3)
export const formatToMoscowTime = (dateString: string, granularity: 'hour' | 'day'): string => {
  const date = new Date(dateString)

  if (granularity === 'hour') {
    // Format hour: "14:00" in Moscow time
    return new Intl.DateTimeFormat('ru-RU', {
      timeZone: 'Europe/Moscow',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date)
  } else {
    // Format date: "17 янв" in Moscow time
    return new Intl.DateTimeFormat('ru-RU', {
      timeZone: 'Europe/Moscow',
      day: 'numeric',
      month: 'short'
    }).format(date)
  }
}

// Format timeout in seconds to readable string
export const formatTimeout = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  if (hours >= 24) {
    return `${hours / 24} д`
  }
  if (hours > 0) {
    return `${hours} ч`
  }
  return `${minutes} мин`
}

// Validate bot token format
export const validateBotToken = (token: string): boolean => {
  const tokenRegex = /^\d+:[A-Za-z0-9_-]{35}$/
  return tokenRegex.test(token)
}

// Truncate string with ellipsis
export const truncate = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) return str
  return `${str.slice(0, maxLength)}...`
}

// Calculate available balance (spendable money)
export const calculateAvailableBalance = (
  balance: number,
  resource_retention: number
): number => {
  return balance - resource_retention
}

// Get holding fee amount based on resource type
export const getHoldingFeeAmount = (resourceType: string): number => {
  return resourceType === 'boost' ? 5.0 : 0.5
}

// Format balance with status for display
export const formatBalanceWithStatus = (
  available: number,
  required: number
): { formatted: string; isInsufficient: boolean } => {
  return {
    formatted: `${available.toFixed(2)} USDT`,
    isInsufficient: available < required
  }
}
